/* stylelint-disable length-zero-no-unit */
import { css } from '@sitebase/emotion';

export var buttonGroupRow = /*#__PURE__*/css('display:flex;width:100%;');

export var buttonGroupCell = /*#__PURE__*/css('margin:0;padding:0;box-sizing:border-box;flex:1 1 0px;display:flex;align-items:center;justify-content:center;border-bottom:1px solid transparent;&:not(:first-child){border-left:1px solid transparent;}');

export var buttonGroup = /*#__PURE__*/css('width:100%;');